<!--
 * @Author: your name
 * @Date: 2020-08-24 19:58:41
 * @LastEditTime: 2021-11-12 16:59:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\components\mall-public\public-search.vue
-->
<template>
  <div class="logo-search-box">
    <div class="mall-logo-box">
      <div :class="['mall-logo', mallName ? '' : 'no-title']">
        <a :href="logoLink" target="_self" class="logo-link">
          <img class="logo" :src="logoUrl | imgHost" alt="">
        </a>
        <span class="line" v-if="mallName"></span>
        <span :class="{'mall-key-words': true, 'mall-img': mallNameType === 1}">
          <span v-if="mallNameType === 0">{{mallName}}</span>
          <img :src="mallName | imgHost" alt="" class="mall-name-img" v-else-if="mallNameType === 1">
        </span>
      </div>
    </div>
    <div v-if="!isDemand" class="search-btn-content">
      <div class="search-info">
        <!-- 下拉 -->
        <div class="search-tab-content">
          <p class="current-search-angle">
            <span>
              {{currentActive === '0' ? pageText.goods : pageText.supplier}}
            </span>
            <i class="iconfont arrow">&#xe7d0;</i>
          </p>
          <ul class="search-tab">
            <li
              :key="tab.name"
              v-for="tab in searchTab"
              @click="tabSwitch(tab)"
              v-on:mouseover="changeActive(tab.name)"
              v-on:mouseout="removeActive(tab.name)"
              :class="{
                'category-background-color-hover': tab.name === activeName,
                'font-color-primary': tab.name === currentActive
              }">
              <span>{{tab.label}}</span>
            </li>
          </ul>
        </div>
        <!-- 输入框 -->
        <input type="text" v-model.trim="name" :placeholder="tips"  @keyup.enter="searchProducts" class="search-input" >
        <!-- 按钮 -->
        <span @click="searchProducts" class="single-btn" data-spm-d='d118'>{{pageText.search}}</span>
      </div>
      <div class="button-box">
        <Buttons
          v-if="isFunctionDepartment && nonDirType === '2'"
          size="mini"
          :to="{name: 'pr-manually-create-edit'}"
          data-spm-d='d120'
          type="textPlain">
          {{pageText.createPurchaseRequisitions}}
        </Buttons>
        <template v-if="isFunctionDepartment && nonDirType !== '2'">
          <!--非职能提示 -->
          <a :href="nonDirType === '3' ? nonDirLink : '/#/req'" v-if="!isGetCity || isFixed">
            <Buttons size="mini" type="textPlain" data-spm-d='d120'>{{nonCatalogNameLabel}}</Buttons>
          </a>
          <span class="offstore-tip" v-else>
            <el-popover
              placement="bottom"
              width="485"
              trigger="manual"
              popper-class="guide-popover"
              v-model="isGuide">
              <i class="triggle"></i>
              <p>{{pageText.noNeedProduct}}</p>
              <div class="guide-know-btn" @click="closeGuide">
                {{pageText.know}}
              </div>
              <template slot="reference">
                <a :href="nonDirType === '3' ? nonDirLink : '/#/req'">
                  <Buttons size="mini" type="textPlain" data-spm-d='d120'>{{nonCatalogNameLabel}}</Buttons>
                </a>
              </template>
            </el-popover>
          </span>
        </template>
        <sy-link :to="{name: 'cart'}" class="shopping">
          <Buttons type="textPlain" size="mini" data-spm-d='d119'>
            <span class="iconfont shopping-icon">&#xe7c7;</span>
            <span  v-show="number" class="number">{{number > 99 ? '99+' : number}}</span>
            <!--购物车小球-->
            <span class="balls">
              <shop-cart-animation :distance="distance" :isFixed="isFixed"></shop-cart-animation>
            </span>
          </Buttons>
        </sy-link>
      </div>
    </div>
  </div>
</template>

<script>
import ShopCartAnimation from './shop-cart-animation'
import Clickoutside from './clickoutside'
import Api from './api.js'
import response from 'fe-coms/utils/response'
import { getUrl } from '@/utils/url.js'
import {mapState, mapGetters} from 'vuex'
import i18n from './i18n.js'
import {Buttons, SyLink} from 'fe-coms'
import createDOMPurify from 'dompurify'
const DOMPurify = createDOMPurify(window)
const pageText = window.fe.getPageText(i18n)
export default {
  name: 'header',
  components: {
    ShopCartAnimation,
    Buttons,
    SyLink
  },
  directives: { Clickoutside },
  props: {
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    let isGuide = this.$parent.getItem('userGuide') !== 'true'
    return {
      path: this.$route.path,
      pageText,
      pageInfo: {},
      showSupplierName: true, // header展示供应商
      distance: {
        top: 0,
        left: 0
      },
      pageCode: '',
      mallName: '',
      isGuide, // 是否显示引导
      isResponse: false,
      isGetCity: true,
      searchTab: [
        {name: '0', label: pageText.goods},
        {name: '1', label: pageText.supplier}
      ],
      tips: pageText.enterKeyWord,
      activeName: '',
      mallNameType: 0,
      currentActive: this.$route.query.currentActive || '0'
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (n, o) {
        if (this.path === this.$route.path) {
          this.name = this.$route.query.q || this.$route.query.materielCode || ''
          this.getPageInfo()
        }
      }
    },
    isAuth: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getListByRuleKey()
        }
      }
    }
  },
  methods: {
    getUrl,
    variableReplace: window.fe.variableReplace,
    changeActive (tab) {
      this.activeName = tab
    },
    removeActive (tab) {
      this.activeName = ''
    },
    // 关闭引导
    closeGuide () {
      this.isGuide = false
      this.$parent.setItem('userGuide', true)
    },
    tabSwitch (tab) {
      this.currentActive = tab.name
      if (this.currentActive === '0') {
        this.tips = this.pageText.enterKeyWord
      } else if (this.currentActive === '1') {
        this.tips = this.pageText.enterSupplier
      }
      if (!this.name) return
      this.searchData()
    },
    // 搜索事件
    searchProducts () {
      window.fe.spmD('d118')
      if (!this.name) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: this.tips
        })
        return
      }
      if (this.name.length > 60) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: this.variableReplace(this.pageText.enterNoMoreThan, {n: 60})
        })
        return
      }
      this.searchData()
    },
    searchData () {
      this.$router.push('/list?q=' + encodeURIComponent(this.name) + '&_t=' + new Date().getTime() + '&currentActive=' + this.currentActive)
    },
    check_is_img (url) {
      return (url.match(/\.(jpeg|jpg|png|bmp|gif|svg)$/) !== null)
    },
    async getPageInfo () {
      if (this.$route.query && this.$route.query.pageInfo) {
        this.pageInfo = JSON.parse(this.$route.query.pageInfo)
        this.getData()
        this.getPageName()
        return
      }
      let pageCode = this.$route.params?.id || ''
      let api = Api.pageGet
      let params = {
        code: pageCode || 'index'
      }
      let res = await response(this.$http(api.type, api.url, params))
      if (res.isOk) {
        this.pageInfo = res.content || {}
        this.getData()
        if (this.pageInfo.sysPurPageCode) {
          this.getPageName()
        }
      }
    },
    // 获取商城标题
    async getPageName () {
      let api = Api.pageName
      let params = {
        sysPurPageCode: this.pageInfo.sysPurPageCode || Number(this.$route.query?.pageInfo?.sysPurPageCode)
      }
      let res = await response(this.$http(api.type, api.url, params))
      if (res.isOk) {
        this.mallName = res.content || ''
        this.mallNameType = this.check_is_img(this.mallName) ? 1 : 0
        if (this.mallNameType === 0) {
          document.title = this.mallName
        }
      }
    },
    // 获取用户数据
    async getData () {
      let api = Api.homeBasic
      let params = {
        set: [1, 2, 3, 4, 5],
        sysPurPageCode: this.pageInfo.sysPurPageCode
      }
      let res = await response(this.$http(api.type, api.url, params))

      //装修中。。。

      if (res.isOk) {
        this.setStore(res.content)
        this.isResponse = true
      }
    },
    setStore (data) {
      this.$store.commit('SET_USERINFO', data.userVo || {})
      this.$store.commit('SET_USERINFO_TEMPLATE', data.userInfoLocation ?? 0)
      if (!data.thisSite || (!data.thisSite.cityCode && !data.thisSite.provinceCode)) {
        this.$emit('noSite')
        this.isGetCity = false
      } else {
        this.isGetCity = true
        if (data.userVo) {
          this.$store.commit('SET_SITE', data.thisSite)// 地区
        } else {
          const cacheSite = window.localStorage.getItem('cacheNoLoginSite') || null
          if (cacheSite) {
            this.$store.commit('SET_SITE', JSON.parse(cacheSite))
          } else {
            this.$store.commit('SET_SITE', data.thisSite)
            window.localStorage.setItem('cacheNoLoginSite', JSON.stringify(data.thisSite))
          }
        }
      }
      this.$store.commit('SET_CARTCOUNT', data.shoppingcartCount)// 购物车数量
      this.$store.commit('SET_LOGOINFO', {
        logoUrl: data.header.logoUrl,
        logoLink: data.header.logoLink
      })
      this.$store.commit('SET_ISSEARCHCENTER', data.header.site)
      this.$store.commit('SET_NONDIRTYPE', data.nonCateConfig?.nonDirType || '')
      this.$store.commit('SET_NONDIRLINK', data.nonCateConfig?.nonDirLink || '')
      this.$store.commit('SET_ISFUNCTIONDEPARTMENT', data.nonCateConfig?.isexist || null)
      this.$store.commit('SET_CHANNELMENU', DOMPurify.sanitize(data.header.channelMenu, {ADD_ATTR: ['target']}))
      this.$store.commit('SET_BOTTOMCONTENT', DOMPurify.sanitize('<div style="display: none;"></div>' + data.bottomContent, {ADD_ATTR: ['target']}))
      this.$store.commit('SET_HEADERTOPCONTENT', DOMPurify.sanitize('<div style="display:none"></div>' + data.header.topContent, {ADD_ATTR: ['target']}))
    },
    // 非商城按钮名称显示配置
    async getListByRuleKey () {
      const api = Api.listByRuleKey
      const params = [
        'mall_purchase_name_config'
      ]
      const res = await response(this.$http(api.type, api.url, params))
      if (res.isOk) {
        const ruleObj = res.content || {}
        // 非商城按钮名称
        const nonCatalogName = {
          'zh-CN': ruleObj.mall_purchase_name_config?.value,
          en: ruleObj.mall_purchase_name_config?.options?.mall_purchase_name_config[0]?.value
        }
        this.$store.commit('SET_NONCATALOG_NAME', nonCatalogName)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.shoppingNumber) {
        let rect = this.$refs.shoppingNumber.getBoundingClientRect()
        this.distance = {
          top: rect.top,
          left: rect.right - 50
        }
      }
    })
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    // 把 `this.cartCount` 映射为 `this.$store.getters.cartCount`
    ...mapState({
      number: state => state.cart.cartCount,
      logoUrl: state => state.user.logoUrl,
      logoLink: state => state.user.logoLink,
      isFunctionDepartment: state => state.user.isFunctionDepartment,
      nonDirType: state => state.user.nonDirType,
      nonDirLink: state => state.user.nonDirLink,
      portalCode: state => state.checkAuth.portalCode,
      isAuth: state => state.user.isAuth
    }),
    ...mapGetters(['nonCatalogNameLabel']),
    // 是否为需求工作台
    isDemand () {
      return this.portalCode === 'demandPortal'
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-search-box {
  display: flex;
  justify-content: space-between;
  align-content: center;
  height: 40px;
  background: #fff;
  padding: 0 16px;
  border-bottom: 1px solid #EFF2F9;
  .mall-logo-box {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    .no-title {
      width: 220px !important;
    }
    .mall-logo{
      display: flex;
      display: -webkit-flex;
      flex-wrap: nowrap;
      align-items: center;
      text-align: right;
      width: 292px;
      max-height: 28px;
      .logo{
        max-height: 28px;
        max-width: 100%;
        vertical-align: middle;
        cursor: pointer;
      }
      .line{
        background-color: #E2E7F4;
        margin: 0 10px;
        display: inline-block;
        height: 13px;
        width: 2px;
      }
      .mall-key-words{
        flex: none;
        height: 100%;
        font-size: 14px;
        color: #242F57;
        max-width: 160px;
        .mall-name-img{
          max-height: 28px;
          max-width: 160px;
          vertical-align: middle;
        }
        &.mall-img{
          max-width: 160px;
        }
      }
    }
  }
  .search-btn-content {
    display: flex;
    align-items: center;
    .search-info {
      display: flex;
      align-items: center;
      border: 1px solid #E2E7F4;
      width: 440px;
      height: 28px;
      box-sizing: border-box;
      border-radius: 4px;
      .search-tab-content {
        color: #636E95;
        width: 73px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FBFCFE;
        border-radius: 4px 0px 0px 4px;
        font-size: 12px;
        position: relative;
        flex-shrink: 0;
        cursor: pointer;
        .arrow {
          font-size: 8px;
          vertical-align: top;
          display: inline-block;
          transform: scale(0.68);
        }
        &:hover {
          .arrow {
            transform: scale(0.68) rotate(180deg);
          }
          .search-tab {
            display: block;
          }
        }
        .search-tab {
          position: absolute;
          left: 0;
          top: 26px;
          background: #FFFFFF;
          box-shadow: 0 0 6px 0 rgba(0,0,0,0.16);
          border-radius: 4px;
          width: 104px;
          padding: 10px 0;
          display: none;
          li{
            font-size: 12px;
            height: 28px;
            line-height: 28px;
            color: #666;
            cursor: pointer;
            padding: 0 12px;
            &:first-child{
              margin-bottom: 2px;
            }
          }
        }
      }
      .search-input{
        outline: none;
        border: none;
        font-size: 12px;
        color: #242F57;
        padding: 0 12px;
        width: 100%;
      }
      /* WebKit browsers */
      .search-input::-webkit-input-placeholder {
        color: #BFC7E0 !important;
        font-size: 12px !important;
      }
      /* Mozilla Firefox 4 to 18 */
      .search-input:-moz-placeholder {
        color: #BFC7E0 !important;
        font-size: 12px !important;
        opacity: 1 !important;
      }
      /* Mozilla Firefox 19+ */
      .search-input::-moz-placeholder {
        color: #BFC7E0 !important;
        font-size: 12px !important;
        opacity: 1 !important;
      }
      /* Internet Explorer 10+ */
      .search-input:-ms-input-placeholder {
        color: #BFC7E0 !important;
        font-size: 12px !important;
      }
      .single-btn {
        width: 60px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        background: #F3F4FA;
        color: #636E95;
        text-align: center;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        flex-shrink: 0;
        &:hover {
          opacity: 0.7;
        }
      }
      .search-group-btn {
        position: absolute;
        right: 0px;
        top: 0px;
        // width: 100px;
        text-align: center;
        ::v-deep.el-button {
          text-align: center;
          width: 100px;
          padding: 0;
          border-radius: 0 6px 6px 0;
          font-weight: 400;
        }
      }
      // 搜索历史列表
      .search-history {
        position: absolute;
        left: 0;
        top: 56px;
        background: #fff;
        min-height: 300px;
        width: 100%;
        z-index: 100;
        box-shadow: 0px 0px 16px rgba(57, 121, 201, 0.2);
        border-radius: 8px;
        padding: 14px 0 20px 0;
        box-sizing: border-box;
        font-size: 12px;
        cursor: pointer;
        .item {
          padding: 0 10px 0 14px;
          line-height: 30px;
          color: #242F57;
          &:hover {
            background: #F3F4FA;
            i {
              display: block;
            }
          }
          i {
            color: #97A0C3;
            display: none;
          }
        }
        .clear-item {
          margin-top: 20px;
          text-align: right;
          color: #636E95;
          padding-right: 10px;
        }
      }
    }
    .button-box{
      display: flex;
      align-items: center;
      .offstore-tip {
        position: relative;
      }
      .sy-button {
        margin-left: 12px;
      }
      .shopping{
        position: relative;
        .shopping-icon{
          color: #97a0c3;
          font-size: 16px;
          display: block;
        }
        .number{
          min-width: 14px;
          padding: 0 3px;
          height: 14px;
          display: inline-block;
          border-radius: 7px;
          background-color: #F73232;
          color: #fff;
          font-size: 11px;
          line-height: 14px;
          text-align: center;
          position: absolute;
          font-weight: 400;
          top: 0px;
          left: 45px;
        }
        .balls{
          float: right;
          margin-left: -20px;
          z-index: 99999;
          position: relative;
          left: 20px;
        }
      }
    }
  }
  // 有非商城采购提示浮层的样式
  .guide-popover{
    width: 485px;
    min-height: 36px;
    padding: 6px 12px;
    line-height: 22px;
    box-sizing: border-box;
    top: 26px;
    right: 0;
    font-size: 12px;
    color: #666666;
    background: #FFF4E6;
    border: 1px solid #FFEACF;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.08);
    .triggle{
      position: absolute;
      top: -6px;
      right: 40px;
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid #FFF4E6;
    }
    p{
      display: inline-block;
    }
    .guide-know-btn{
      float: right;
      width: 56px;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      color: #FFFFFF;
      background: #FFA535;
      border: 1px solid #F99519;
      border-radius: 2px;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
</style>
